import { GameSource } from "./GameSource.js";
import type { RollGameEvent } from "../../event/RollGameEvent.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import { GameUpdateEvent } from "./GameUpdateEvent.js";
import type { GamePlayers } from "../../../api/game/GamePlayers.js";
import type { AnalyticsProvider } from "../../../analytics/Analytics.js";
import type { MessageOutUploadGame } from "../../../api/game/MessageOutUploadGame.js";
import type { GameAPI } from "../../../api/GameAPI.js";
import type { APIGameAnalysisOverview, APIGamePreferences } from "../../../api/api_schema.js";
import type { GameClientControls } from "../../../GameClientControls.js";
import type { ReactionType } from "../../ReactionType.js";
import type { GameEndReason } from "../../GameEndReason.js";
import type { KnownLobbySettings } from "../../KnownLobbySettings.js";
import type { Game } from "../../../../royalur/Game.js";
import { AnalysisLobbyStatus } from "../status/AnalysisLobbyStatus.js";
import { Optional } from "../../../../util/Optional.js";
import { LobbyID } from "../../../lobby/LobbyID.js";


export class AnalysisGameSource extends GameSource {
    constructor(
        initialClientControls: GameClientControls,
        initialPreferences: APIGamePreferences,
        analytics: AnalyticsProvider,
        gameAPI: GameAPI,
        settings: KnownLobbySettings,
        game: Game,
        players: GamePlayers,
        endReason: GameEndReason,
        endingPlayer: PlayerType | null,
        completeGameID: string,
        analysisOverview: APIGameAnalysisOverview | null,
    ) {
        super(
            initialClientControls, initialPreferences, analytics, gameAPI, settings,
            new AnalysisLobbyStatus(
                LobbyID.ofCompleteGame(completeGameID),
                settings, endReason, endingPlayer, completeGameID,
            ),
            game.getRules(),
        );
        this.game.set(game, new GameUpdateEvent(false));
        this.analysisOverview.set(Optional.ofNullable(analysisOverview));
        this.players.set(players);
    }

    override getControllerMaxDirectives(): number {
        return 0;
    }

    override isLocalHumanPlayer(_playerType: PlayerType): boolean {
        return false;
    }

    override setup(): () => void {
        return () => {};
    }

    override handleResign(): void {
        throw new Error("AnalysisGameSource does not support handleResign");
    }

    override handleMove(): void {
        throw new Error("AnalysisGameSource does not support handleMove");
    }

    override handleRoll(_event: RollGameEvent): void {
        throw new Error("AnalysisGameSource does not support handleRoll");
    }

    override handleReaction(_player: PlayerType | null, _reaction: ReactionType) {
        throw new Error("AnalysisGameSource does not support handleReaction");
    }

    override shouldUploadGame(): boolean {
        return false;
    }

    override buildUploadGameMessage(): MessageOutUploadGame {
        throw new Error("AnalysisGameSource does not support buildUploadGameMessage");
    }
}
